import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './base';
import { EmailStatsDTO } from '../../models/email';
import { Response } from '../../models/shared';

const emailApi = createApi({
  reducerPath: 'emailApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['email'],
  endpoints: (builder) => ({
    getEmailStats: builder.query<EmailStatsDTO | null, { start: string; end: string }>({
      query: ({ start, end }) => ({
        url: '/email/stats',
        method: 'GET',
        params: { start, end },
      }),
      providesTags: ['email'],
      transformResponse: (response: Response<EmailStatsDTO>) => response.data || null,
    }),
  }),
});

export const {
  useGetEmailStatsQuery,
} = emailApi;

export { emailApi };
